import { Button, styled } from "@mui/material";

export const GridButton = styled(Button)({
    alignSelf:'center', marginTop:'5px', marginLeft:'5px', textTransform:'unset'
})